{
  "footer": {
    "alreadyPartner": "Al een partner?",
    "back": "Terug",
    "letsgo": "Laten we starten!",
    "login": "Inloggen",
    "next": "Volgende",
    "readMore": "Meer informatie",
    "signUp": "Aanmelden"
  },
  "formErrors": {
    "address": "Dit adres kan niet worden gevonden. Vul alsjeblieft een bestaand adres in",
    "businessName": "Deze naam is niet beschikbaar. Kies een andere naam",
    "email": "Dit e-mailadres is al in gebruik",
    "verificationCode": "Ongeldige code"
  },
  "global": {
    "title": "Sluit je aan bij Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Bedrijfsnaam is te lang",
      "label": "Bedrijfsnaam",
      "required": "Verplicht"
    },
    "businessSegment": {
      "aesthetics": "Esthetica",
      "barber": "Barber",
      "beautician": "Beauty",
      "hair-removal": "Ontharen",
      "hairdresser": "Kapper",
      "massage": "Massage",
      "nails": "Nagels",
      "primary": "Primaire",
      "required": "Selecteer minstens één",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Ik bevestig dat ik een speciale en aparte ruimte heb voor mijn bedrijf",
      "home": "Thuis gevestigd <0>- klanten komen naar jou toe</0>",
      "mobile": "Mobiel  <0>- je gaat naar jouw klanten toe</0>",
      "mobileCheckbox": "Ik wil Treatwell ALLEEN gebruiken als boekingssoftware en NIET voor de Marktplaats.",
      "mobileMessage": "Helaas kan onze Marktplaats alleen bedrijven met een vast adres weergeven.",
      "required": "Selecteer één",
      "shop": "Salon <0>- klanten komen naar de salon</0>"
    },
    "city": {
      "invalid": "Stad is te lang",
      "label": "Stad",
      "required": "Verplicht"
    },
    "country": {
      "label": "Land",
      "required": "Verplicht"
    },
    "email": {
      "invalid": "Ongeldig",
      "label": "E-mail",
      "required": "Verplicht"
    },
    "firstName": {
      "invalid": "Gebruik geen speciale tekens",
      "label": "Voornaam",
      "required": "Verplicht"
    },
    "lastName": {
      "invalid": "Gebruik geen speciale tekens",
      "label": "Achternaam",
      "required": "Verplicht"
    },
    "marketing": {
      "label": "Ik wil graag e-mails ontvangen om mijn bedrijf te laten groeien met deskundig advies."
    },
    "password": {
      "hint": "Minimaal 8 tekens",
      "invalid": "Wachtwoord heeft tenminste 8 tekens nodig",
      "label": "Wachtwoord",
      "required": "Verplicht"
    },
    "phoneNumber": {
      "invalid": "Ongeldig telefoonnummer",
      "label": "Telefoonnummer",
      "required": "Verplicht"
    },
    "postalCode": {
      "invalid": "Postcode is te lang",
      "label": "Postcode",
      "required": "Verplicht"
    },
    "privacy": {
      "label": "Door je aan te melden voor het Freemium Account ga je akkoord met ons <0>Privacybeleid</0> en <1>de Algemene Voorwaarden</1>."
    },
    "searchBusiness": {
      "label": "Zoek bedrijf"
    },
    "street": {
      "invalid": "Adres is te lang",
      "label": "Adres",
      "required": "Verplicht"
    }
  },
  "salesMode": {
    "enterPassword": "Voer wachtwoord in voor verkoopmodus",
    "invalidPassword": "Ongeldig wachtwoord"
  },
  "stepContext": {
    "attractNewClients": "Trek nieuwe klanten aan",
    "buildRelationships": "Bouw nog betere relaties op met je klanten",
    "growBusiness": "Laat je bedrijf prachtig groeien",
    "manageAppointments": "Beheer al je afspraken onderweg",
    "prompt": "Je bent slechts een paar stappen (en ongeveer 3 minuten) verwijderd van jouw moment of fame op Treatwell. Sluit je aan bij meer dan 75.000 salons die met Treatwell hun bedrijf efficiënt beheren, hun klantenbestand aanzienlijk uitbreiden en hun omzet verhogen.",
    "prompt2": "...en nog veel meer",
    "title": "<0>Lid worden van Treatwell</0> - Europa's grootste platform voor haar- en beautysalons - het was nog nooit zo eenvoudig."
  },
  "stepCounter": {
    "step0": "Stap 1",
    "step1": "Stap 1",
    "step2": "Stap 2",
    "step3": "Stap 3",
    "step4": "Stap 4",
    "step5": "Gefeliciteerd"
  },
  "stepEmailVerification": {
    "resend": "Opnieuw versturen",
    "subTitle1": "Voer de code in om je aanmelding te voltooien.",
    "subTitle2": "Niets ontvangen?",
    "title": "<0>Het is bijna zover.</0> We hebben je een e-mail gestuurd met een 6-cijferige code!"
  },
  "stepError": {
    "accountCreation": "jouw account wordt aangemaakt",
    "body": "Er gaat iets niet goed. Wacht even en probeer het opnieuw.",
    "bodyWithError": "Er gaat iets niet goed met {{reason}}. Wacht even en probeer het nog een keer.",
    "button": "Opnieuw",
    "title": "Oeps, er gaat iets mis!"
  },
  "stepFinal": {
    "joke1Punchline": "Pony weg",
    "joke1Setup": "Komt een cowboy bij de kapper, hij komt naar buiten en wat denk je?",
    "joke2Punchline": "Schoonheidsspecialiste: “Het licht uitdoen.”",
    "joke2Setup": "Een vrouw zegt tegen de schoonheidsspecialiste: “Wat kun je doen voor mijn rimpels?”",
    "joke3Punchline": "“Sorry, ik had een bad hair day!”",
    "joke3Setup": "Wat zei de beauty influencer toen ze te laat was voor haar eigen tutorial?",
    "joke4Punchline": "Jongen: zoals papa: met een gat in het midden",
    "joke4Setup": "Kapper: En jongeman, hoe wil je je haar geknipt hebben?",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "Terwijl je wacht, zijn deze knip-grappig!",
    "title": "Bedankt! Wij maken nu jouw account klaar voor gebruik. <br />Geef ons <0>twee minuten...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Aanmelden",
    "alternativeMessage": "Gebruik je dezelfde locatie om een nieuw bedrijf aan te melden?",
    "button": "Treatwell Login",
    "message": "<0>Goed nieuws! </0> Je bedrijf is al aangemeld bij Treatwell."
  },
  "stepFourForm": {
    "prompt1": "We gebruiken deze informatie om je account aan te maken en om contact op te nemen, mocht dit nodig zijn.",
    "title": "Vertel iets over jezelf"
  },
  "stepOneForm": {
    "prompt1": "Zoek of voer je bedrijfsnaam in",
    "title": "Vertel ons over jouw bedrijf"
  },
  "stepOneSearch": {
    "addManually": "Kun je jouw bedrijf niet vinden? <0>Voer het handmatig in</0>",
    "prompt1": "Typ jouw bedrijfsnaam",
    "title": "Vertel ons over jouw bedrijf"
  },
  "stepThreeForm": {
    "title": "Wat voor soort bedrijf heb je?"
  },
  "stepTwoForm": {
    "prompt1": "Selecteer alles wat van toepassing is. Start met de meest geleverde service",
    "title": "Wat voor behandelingen bied je aan?"
  }
}